/**
 * marketScale — 12/02/2026
 *
 * Multiplicateur d'échelle dynamique appliqué aux concurrents et aux
 * Appels d'Offres afin qu'ils restent pertinents à mesure que le joueur
 * progresse. Retour user prod :
 *   1. « Les concurrents ne suivent pas la progression du joueur »
 *      → sans scaling, un joueur en Phase 3 avec 20 camions écrase des
 *        concurrents figés à leurs KPIs de départ. Les rachats/M&A
 *        deviennent triviaux financièrement.
 *   2. « Les AO doivent rester plus attractifs que les contrats
 *        standards en mid-late game »
 *      → sans scaling, la prime AO (30/35 %) devient marginale face aux
 *        contrats catalogue premium en fin de partie.
 *
 * Formule (combinaison des trois critères, cf. choix utilisateur) :
 *   phaseBoost  = clamp((phase - 1) × 0.05, 0, 0.20)   // +5 % / phase (max +20 %)
 *   fleetBoost  = clamp(fleet / 200, 0, 0.20)          // +1 % / 2 camions (max +20 %)
 *   daysBoost   = clamp(totalDays / 7200, 0, 0.10)     // +1 % / 72 jours (max +10 %)
 *
 * Concurrent : multiplicateur appliqué à `ca`, `fleet`, `drivers`, `equity`.
 *   competitorScale = 1 + phaseBoost + fleetBoost + daysBoost   (max 1.50×)
 *
 * AO : bonus additif sur `TENDER_BONUS_PCT`.
 *   aoBonusBoost = phaseBoost + fleetBoost × 0.5              (max +30 %)
 */

export function computeMarketScale({ phase = 1, fleetSize = 0, totalDays = 0 } = {}) {
  const phaseBoost = Math.min(0.20, Math.max(0, (phase - 1) * 0.05));
  const fleetBoost = Math.min(0.20, Math.max(0, fleetSize / 200));
  const daysBoost  = Math.min(0.10, Math.max(0, totalDays / 7200));

  const competitorScale = Math.min(1.50, 1 + phaseBoost + fleetBoost + daysBoost);
  const aoBonusBoost = Math.min(0.30, phaseBoost + fleetBoost * 0.5);

  return {
    phaseBoost,
    fleetBoost,
    daysBoost,
    competitorScale,
    aoBonusBoost,
  };
}

/**
 * Sucre syntaxique : lit `state` directement.
 */
export function marketScaleFromState(state) {
  return computeMarketScale({
    phase: state?.phase || 1,
    fleetSize: (state?.vehicles || []).length,
    totalDays: state?.totalDays || 0,
  });
}
